

























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import AccountAddRecords from '@/components/account/AccountAddRecords.vue';
import AccountCopyRecords from '@/components/account/AccountCopyRecords.vue';
import AccountRecordsAdded from '@/components/account/AccountRecordsAdded.vue';
import { SingleFolderInterface } from '@/interfaces/SingleFolderInterface';
import { ProjectListItem } from '@/interfaces/ProjectListItem';
import { SingleRecordDetailsInterface } from '@/interfaces/SingleRecordDetailsInterface';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';

interface ProjectItemData {
    prodGroup: string;
    brandId: number;
    projectId: number;
}

@Component({
    components: {
        AccountAddRecords,
        AccountCopyRecords,
        AccountRecordsAdded,
    },
    name: 'SingleFolder',
})
export default class SingleFolder extends Vue {
    @Action('user/getCurrentStatisticalAnalysis')
    protected getCurrentStatisticalAnalysis!: (ids: number[]) => void;
    @Action('projects/downloadBrand') protected downloadBrand!: ({
        id,
        projectName,
    }: {
        id: number;
        projectName: string;
    }) => Promise<string>;
    @Action('projects/downloadMultipleBrands')
    protected downloadMultipleBrands!: ({
        ids,
        projectName,
    }: {
        ids: string;
        projectName: string;
    }) => Promise<string>;
    protected disableButton: boolean = true;
    protected isAddRecordsDialogVisible = false;
    protected isCopyRecordsDialogVisible = false;
    protected isAccountRecordsAdded = false;
    protected checkList: SingleFolderInterface[] = [];
    protected recordIdToCopy: number | null = null;
    protected idsBeingDownloaded: number[] = [];
    protected isButtonEnabled = true;
    protected brandIds: number[] = [];
    protected withoutDuplicates: number[] = [];
    protected duplicates: number[] = [];
    protected noDuplicatesIds: number[] = [];
    @Action('projects/getSingleReport')
    private getSingleReport!: (id: number) => void;
    @Action('projects/deleteProjectItem')
    private deleteProjectItem!: (id: number) => void;
    @Action('projects/getSingleProject')
    private getSingleProject!: (id: number) => void;
    @Action('projects/addProjectItem')
    private addProjectItem!: (projectItemData: ProjectItemData) => void;
    @Action('projects/getProjectItems')
    private getProjectItems!: () => void;
    @Action('user/setActiveProductGroup') private setActiveProductGroup!: (
        productGroup: ProductGroupTypes,
    ) => void;

    protected get getTableData() {
        if (!this.activeProject) {
            return [];
        }
        return this.activeProject.projectItems;
    }

    protected get activeProject() {
        return this.$store.getters['projects/activeProject'];
    }

    protected get myProjects() {
        return this.$store.getters['projects/myProjectsList'];
    }

    protected get allProjectItems() {
        return this.$store.getters['projects/allProjectItems'];
    }

    protected get projectsIdsWithoutCurrent() {
        if (!this.myProjects.length) {
            return [];
        }
        const projectDialogData = this.myProjects.map(
            (project: ProjectListItem) => {
                return {
                    name: project.name,
                    id: project.id,
                };
            },
        );
        if (!this.activeProject) {
            return projectDialogData;
        }
        return projectDialogData.filter(
            (project: { name: string; id: number }) =>
                project.id !== this.activeProject.id,
        );
    }

    protected usdRevenuesNormalized(usdRevenues: string) {
        if (usdRevenues) {
            const revenueValue = Math.round(
                parseFloat(usdRevenues.replace(',', '.')),
            );
            if (isNaN(revenueValue)) {
                return '';
            }
            return `USD ${revenueValue} million`;
        }
        return '';
    }

    protected async mounted() {
        await this.getProjectItems();
    }

    protected handleSelectionChange(val: SingleFolderInterface[]) {
        this.checkList = val;
    }

    protected async openReportDetails(row: SingleFolderInterface) {
        await this.getSingleReport(row.id);
        this.$router.push({ name: 'SingleRecordDetails' });
    }

    protected async onAnalysisConduct() {
        const projectDataItems = this.checkList.map((element: any) => {
            return element.brand;
        });
        await this.getCurrentStatisticalAnalysis(
            projectDataItems.map((record) => record.id),
        );
        this.$router.push({ name: 'StatisticalAnalysis' });
    }

    protected closeDialog(type: string) {
        if (type === 'add') {
            this.isAddRecordsDialogVisible = false;
        }
        if (type === 'copy') {
            this.isCopyRecordsDialogVisible = false;
            this.recordIdToCopy = null;
        }
        if (type === 'message') {
            this.isAccountRecordsAdded = false;
        }
    }

    protected openDialog(type: string, id: number) {
        if (type === 'add') {
            this.isAddRecordsDialogVisible = true;
        }
        if (type === 'copy') {
            this.isCopyRecordsDialogVisible = true;
            this.recordIdToCopy = id;
        }
    }

    protected async onDeleteItem(id: number) {
        if (this.activeProject.isMain) {
            return;
        }
        await this.deleteProjectItem(id);
        this.getSingleProject(this.activeProject.id);
    }

    protected async onCopyRecords(projectIds: number[]) {
        if (this.recordIdToCopy) {
            for await (const id of projectIds) {
                await this.addProjectItem({
                    prodGroup: this.activeProject.prodGroup,
                    brandId: this.recordIdToCopy,
                    projectId: id,
                });
            }
        }
        this.closeDialog('copy');
    }

    protected findDuplicates(num: number) {
        const temp = this.activeProject.projectItems.find(
            (x: SingleFolderInterface) => x.brand.id === num,
        );
        this.duplicates.push(temp.brand.importId);
    }

    protected async onAddRecords(recordIds: number[]) {
        this.brandIds = this.activeProject.projectItems.map(
            (projectItem: SingleFolderInterface) => {
                return projectItem.brand.id;
            },
        );
        this.withoutDuplicates = recordIds.filter(
            (x) => !this.brandIds.includes(x),
        );
        this.duplicates = [];
        this.noDuplicatesIds = [];
        const tempDuplicates = recordIds.filter((x) =>
            this.brandIds.includes(x),
        );
        tempDuplicates.forEach((element) => {
            this.findDuplicates(element);
        });
        const tempNoDuplicateIds: any = [];
        recordIds.forEach((element) => {
            if (this.brandIds.includes(element)) {
                return;
            } else {
                tempNoDuplicateIds.push(
                    this.allProjectItems.find(
                        (x: SingleFolderInterface) => x.brand.id === element,
                    ),
                );
            }
        });
        tempNoDuplicateIds.forEach((element: any) => {
            this.noDuplicatesIds.push(element.brand.importId);
        });
        for await (const id of this.withoutDuplicates) {
            await this.addProjectItem({
                prodGroup: this.activeProject.prodGroup,
                brandId: id,
                projectId: this.activeProject.id,
            });
        }
        await this.getSingleProject(this.activeProject.id);
        this.closeDialog('add');
        this.isAccountRecordsAdded = true;
    }

    protected async onNavigateToMyProjects() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.setActiveProductGroup(ProductGroupTypes.None);
        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        this.$router.push({ name: 'MyProjects' });
    }

    protected sortRevenues(a: any, b: any) {
        return this.sortNumberValues(
            +a.brand.usdRevenues,
            +b.brand.usdRevenues,
        );
    }

    protected sortNumberValues(a: number, b: number) {
        if (a === b) {
            return 0;
        } else if (a === null || isNaN(a)) {
            return 1;
        } else if (b === null || isNaN(b)) {
            return -1;
        }
        return a - b;
    }

    protected async onDownloadMultiple() {
        this.isButtonEnabled = false;
        this.$message.info('Generating reports, please wait.');
        const idsToDownload = this.checkList
            .map((checkListItem: SingleFolderInterface) => {
                return checkListItem.id;
            })
            .join(',');
        const projectName = this.activeProject.name;
        const invoice = await this.downloadMultipleBrands({
            ids: idsToDownload,
            projectName,
        });
        const blob = await this.decodePDF(invoice);
        let name = 'Markables_Records_' + this.activeProject.id + '_';
        if (this.activeProject.prodGroup === 't') {
            name = `Markables_Records_${this.activeProject.id}_tm.pdf`;
        } else if (this.activeProject.prodGroup === 'c') {
            name = `Markables_Records_${this.activeProject.id}_cr.pdf`;
        } else if (this.activeProject.prodGroup === 'g') {
            name = `Markables_Records_${this.activeProject.id}_gw.pdf`;
        } else if (this.activeProject.prodGroup === 'e') {
            name = `Markables_Records_${this.activeProject.id}_tc.pdf`;
        } else {
            name = `Markables_Records_${this.activeProject.id}_sw.pdf`;
        }
        // const recordNames = this.checkList.map((checkListItem: SingleFolderInterface) => {
        //     return checkListItem.brand.importId + '_' + checkListItem.brand.valuer;
        // }).join('_');
        this.fileSaver(blob, name);
        this.isButtonEnabled = true;
    }

    protected async onDownload(singleRecord: SingleRecordDetailsInterface) {
        if (this.idsBeingDownloaded.includes(Number(singleRecord.id))) {
            return;
        }
        const projectName = this.activeProject.name;
        this.$message.info('Generating report, please wait.');
        this.idsBeingDownloaded.push(Number(singleRecord.id));
        const invoice = await this.downloadBrand({
            id: Number(singleRecord.id),
            projectName,
        });
        const blob = await this.decodePDF(invoice);
        let name = '';
        if (singleRecord.prodGroup === 't') {
            name =
                `Markables_Record_${singleRecord.brand.importId}_tm_` +
                `${singleRecord.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (singleRecord.prodGroup === 'c') {
            name =
                `Markables_Record_${singleRecord.brand.importId}_cr_` +
                `${singleRecord.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (singleRecord.prodGroup === 'g') {
            name =
                `Markables_Record_${singleRecord.brand.importId}_gw_` +
                `${singleRecord.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else if (singleRecord.prodGroup === 'e') {
            name =
                `Markables_Record_${singleRecord.brand.importId}_tc_` +
                `${singleRecord.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        } else {
            name =
                `Markables_Record_${singleRecord.brand.importId}_sw_` +
                `${singleRecord.brand.brandBusinessComb.replace(
                    /[,. ]+/g,
                    '_',
                )}.pdf`;
        }
        this.fileSaver(blob, name);
        this.idsBeingDownloaded.splice(
            this.idsBeingDownloaded.indexOf(Number(singleRecord.id)),
            1,
        );
    }

    protected async decodePDF(invoice: string) {
        const byteCharacters = atob(invoice);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: 'application/pdf' });
    }

    protected fileSaver(blob: Blob, name: string) {
        const data = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, name);
            return;
        } else if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, name);
            return;
        }
        link.href = data;
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }
}
